
<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li style="font-weight: bold;font-size: x-large;">T.N.M Classification</li>
                </ul>
            </div>
        </div>
    </div>

  </section>
<br>
<section class="w3l-form-25">
  <div id="w3l-appointment">
  <div class="wrapper">
    <div class="appointment-form-field">
      <label style = "width: 125px;">Date                  </label>
      <input type="date" name="site" [(ngModel)]="visdate" style="width: 20%;" required="" />
      <label style="width: 5%;"></label>
      <label style = "width: 125px;">Location            </label>
      <select id="PatientStatus" name="PatientStatus"  style="width: 90%;background-color:  rgb(187, 203, 238);"  required>
        <option value="1">COC </option>
        <option value="2">Shorouk</option>
        <option value="3">Al Salam Hospital</option>
        <option value="4">57357 Hospital</option>
        <option value="5">Others</option>

    </select>

      </div>
     <BR>
    <div class="appointment-form-field">
      <label style = "width: 130px;">Family               </label>
      <select id="PatientStatus" name="PatientStatus" [(ngModel)]="visfamily" style="width: 980%;background-color:  rgb(187, 203, 238);"  required>
        <option value="0">Select* </option>
        <option value="1">Case I </option>
        <option value="2">Case II</option>
        <option value="3">Case III</option>
        <option value="4">Case IV</option>
        <option value="5">NK</option>

    </select>

      </div>
     <BR>
    <div class="appointment-form-field">
    <label style = "width: 130px;">Site                 </label>
    <input type="text" name="site" [(ngModel)]="vissite" style="width: 20%;" required="" />
    <label>              </label>
    <label>Stage   </label>

    <select id="PatientStatus" name="PatientStatus" [(ngModel)]="visstage" style="width: 18%;background-color:  rgb(187, 203, 238);"  required>
      <option value="0">Select* </option>
      <option value="1">Stage I </option>
      <option value="2">Stage II</option>
      <option value="3">Stage III</option>
      <option value="4">Stage IV</option>
      <option value="5">NK</option>

  </select>
  <label>           </label>
  <label>Grade    </label>

  <select id="visgrade" name="visgrade" [(ngModel)]="visgrade" style="width: 18%;background-color:  rgb(187, 203, 238);"   required>
    <option value="0">Select* </option>
    <option value="1">Grade I </option>
    <option value="2">Grade II</option>
    <option value="3">Grade III</option>
    <option value="5">NK</option>

</select>


    </div>
   <BR>
   <div class="appointment-form-field">
      <label style = "width: 130px;">T                     </label>
      <select id="vist" name="vist" [(ngModel)]="vist"  style="width: 20%;background-color:  rgb(187, 203, 238);"    required>
        <option value="">Select* </option>
        <option value="0">0 </option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="Tx">Tx</option>

    </select>
      <label>              </label>
      <label>N          </label>

      <select id="visn" name="visn" [(ngModel)]="visn" style="width: 18%;background-color:  rgb(187, 203, 238);"    required>
        <option value="">Select* </option>
        <option value="0">0 </option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="Nx">Nx</option>

    </select>
    <label>           </label>
    <label>M           </label>

    <select id="vism" name="vism" [(ngModel)]="vism" style="width: 18%;background-color:  rgb(187, 203, 238);"   required>
      <option value="">Select* </option>
      <option value="0">0 </option>
      <option value="1">1</option>
      <option value="Mx">Mx</option>


  </select>


   </div>
 </div>
</div>
<BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" >{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(179, 2, 2);color: white;border-style: none;height: 60%;" name="Delete">{{ 'Delete' | translate }}</button>
    <a href="home">
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
</section>
</mat-dialog-content>
